import { Logger } from "../../logger";

export const logger = Logger("menu");
